// extracted by mini-css-extract-plugin
export default {"cardsContainer":"cards-module__cardsContainer__6gW3n"};